import { Component, OnInit, Input, EventEmitter, Output, OnChanges, OnDestroy } from '@angular/core';
import { MenuServiceService } from '../../services/menu/menu-service.service';
import { Router } from '@angular/router';
import { MenuItem } from '../menu';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { SharedService } from '../../services/shared/shared.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { Subscription } from 'rxjs';
import { MainService } from 'src/app/services/main/main.service';
import { MatDialog } from '@angular/material/dialog';
import { SimpleDialogComponent } from 'src/app/shared/simple-dialog/simple-dialog.component';
import { getUserProfile } from 'src/app/core/session';
@Component({
  selector: 'app-sidemenu',
  templateUrl: './sidemenu.component.html',
  styleUrls: ['./sidemenu.component.scss'],
  animations: [
    trigger('indicatorRotate', [
      state('collapsed', style({ transform: 'rotate(0deg)' })),
      state('expanded', style({ transform: 'rotate(180deg)' })),
      transition('expanded <=> collapsed',
        animate('225ms cubic-bezier(0.4,0.0,0.2,1)')
      ),
    ])
  ]
})
export class SidemenuComponent implements OnInit, OnChanges, OnDestroy {
  @Input() item: MenuItem;
  @Input() depth: number;
  @Input() showName: number;
  @Output() public sidenavToggle = new EventEmitter();
  @Output() public sidenavOpen = new EventEmitter();
  expanded: boolean;
  currentPath: string
  checkPath: string;
  profile = localStorage.getItem('userProfileData') ? getUserProfile(): {};
  auth_profile: Subscription;
/*   is_allowed: any;
  is_allowed1: boolean; */
  arProposalCount : any;
  preapproval_leads_object;
  agent_id : any = 0;
  constructor(
    public menu: MenuServiceService,
    public router: Router,
    public authService: AuthService,
    public sharedService: SharedService,
    public mainService: MainService,
    private dialog: MatDialog,
  ) {
    if (this.depth === undefined) {
      this.depth = 0;
    }
  }

  ngOnInit() {
    this.menu.currentUrl.subscribe((url: string) => {
      this.currentPath = url;
      if (this.item.path && url) {
        this.expanded = url.indexOf(`${this.item.path}`) === 0;
      }
    });
    this.mainService.arProposals.subscribe((data: any) => {
      this.arProposalCount = data;
    });
    this.mainService.preapproval_leads_object.subscribe(data=>{
      this.preapproval_leads_object=data
    })
    this.authService.userProfileData$.subscribe((data)=>{
      this.profile = data[0] || {};
    })
    if(this.profile && this.profile.agent_id){
      this.agent_id = this.profile.agent_id;
    }
  }

  onMenuSelected(item:any) {
    let useCheck;
    useCheck = localStorage.getItem('freeze_url');
    if(useCheck) {
      this.showFreezeUnlockDialog(item);
      return;
    }

    if (item.path == '/app/open-api/pay-over-time' || item.path == '/app/accounts-receivable/dashboard'  || item.path == '/app/help/marketing-material' || item.path == '/app/open-api/api') {
      this.sharedService.getSelectedBusiness(item.path,null,true);
      return;
    }

    if (!item.submenu || !item.submenu.length) {
      this.router.navigate([item.path]);
      this.sidenavToggle.emit();
      if (item.path != window.location.pathname) {
        this.sharedService.resetFinanceFlow(true);
      }
    }
    if (item.submenu && item.submenu.length) {
      this.expanded = !this.expanded;
      if (this.expanded) {
        this.sidenavOpen.emit();
        if (!this.showName) {
          this.showName = 0;
        }
      }
    }
    if (!localStorage.getItem('freeze_url')) {
      if (!item.submenu || !item.submenu.length) {
        this.router.navigate([item.path]);
        this.sidenavToggle.emit();
        if (item.path != window.location.pathname) {
          this.sharedService.resetFinanceFlow(true);
        }
      }
    }

  }

  private showFreezeUnlockDialog(item: any): void {
    const doctorEmail = this.profile?.enterprise_email
      || this.profile?.doctor_email
      || this.profile?.agent_email
      || '';
    const dialogRef = this.dialog.open(SimpleDialogComponent, {
      width: '400px',
      disableClose: true,
      panelClass: 'simpleDialog',
      data: {
        type: 22,
        title: 'Please enter your password to continue',
        send_data: {
          contract_id: 1,
          doctor_id: this.profile?.doctor_id,
          doctor_email: doctorEmail,
          password: ''
        }
      }
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (Number(result) === 1) {
        localStorage.removeItem('switchUserForm');
        localStorage.removeItem('freeze_url');
        localStorage.removeItem('freeze_url_from');
        if (!item.submenu || !item.submenu.length) {
          this.router.navigate([item.path]);
          this.sidenavToggle.emit();
          if (item.path !== window.location.pathname) {
            this.sharedService.resetFinanceFlow(true);
          }
        } else {
          this.expanded = !this.expanded;
          if (this.expanded) {
            this.sidenavOpen.emit();
          }
        }
      }
    });
  }

  checkActiveMenu(item: any) {
    let currentPath = this.currentPath ? this.currentPath.split('?') : '';
    this.checkPath = item.path;
    if (this.currentPath == item.path || currentPath[0] == item.path) {
      return true;
    } else {
      return false;
    }
  }

  isCurrentRoute(item: any) {
    let currentPath = window.location.pathname;
    if (currentPath.indexOf("/app/contract/details") !== -1) {
      currentPath = "/app/contract/list";
    }
    else if (currentPath.indexOf("/app/accounts-receivable/details") !== -1) {
      currentPath = "/app/accounts-receivable/list";
    }
    else if (currentPath.indexOf("/app/process-payment/details") !== -1) {
      currentPath = "/app/process-payment/list";
    }
    return currentPath.indexOf(item.path) !== -1;
  }

  ngOnChanges() {
    if (!this.showName) {
      this.expanded = false;
    } else if (this.item.path && this.currentPath) {
      this.expanded = this.currentPath.indexOf(`${this.item.path}`) === 0;
    }
  }

  checkUserType() {
    let useCheck;
    useCheck = localStorage.getItem('freeze_url');
    if(useCheck) {
      return true
    }
    else {return false}
  }

  ngOnDestroy(): void {
    this.auth_profile && this.auth_profile.unsubscribe();
  }

}
